'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp; /**
                    * @copyright 2015-present, Prometheus Research, LLC
                    */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStylesheet = require('react-stylesheet');

var Stylesheet = _interopRequireWildcard(_reactStylesheet);

var _Component2 = require('./Component');

var _Component3 = _interopRequireDefault(_Component2);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

var _ErrorList = require('./ErrorList');

var _ErrorList2 = _interopRequireDefault(_ErrorList);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Field = (_temp = _class = function (_Component) {
  _inherits(Field, _Component);

  function Field(props) {
    _classCallCheck(this, Field);

    var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props));

    _this.onBlur = function () {
      _this.setState({ dirty: true });
    };

    _this.onChange = function (e) {
      var value = void 0;
      if (e && e.target && e.target.value !== undefined) {
        e.stopPropagation();
        value = e.target.value;
        if (value === '') {
          value = null;
        }
      } else {
        value = e;
      }
      _this.formValue.update(value);
      _this.setState({ dirty: true });
    };

    _this.state = { dirty: false };
    return _this;
  }

  _createClass(Field, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          Input = _props.Input,
          label = _props.label,
          children = _props.children;

      var _ref = this.props.stylesheet || this.constructor.stylesheet,
          Root = _ref.Root,
          ErrorList = _ref.ErrorList,
          Label = _ref.Label,
          InputWrapper = _ref.InputWrapper;

      var dirty = this.state.dirty;
      var _formValue = this.formValue,
          _formValue$schema = _formValue.schema,
          schema = _formValue$schema === undefined ? {} : _formValue$schema,
          value = _formValue.value,
          _formValue$params = _formValue.params,
          params = _formValue$params === undefined ? {} : _formValue$params;

      var showErrors = dirty || params.forceShowErrors;
      if (!children) {
        children = _react2.default.createElement(Input, { value: value, onChange: this.onChange });
      } else {
        children = _react2.default.cloneElement(_react2.default.Children.only(children), { value: value, onChange: this.onChange });
      }
      return _react2.default.createElement(
        Root,
        { onBlur: this.onBlur },
        _react2.default.createElement(Label, { label: label, schema: schema }),
        _react2.default.createElement(
          InputWrapper,
          null,
          children
        ),
        _react2.default.createElement(ErrorList, {
          hideNonForced: !showErrors,
          formValue: this.formValue
        })
      );
    }
  }]);

  return Field;
}(_Component3.default), _class.propTypes = _extends({}, _Component3.default.propTypes, {
  label: _propTypes2.default.string,
  children: _propTypes2.default.element,
  Input: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
}), _class.defaultProps = {
  Input: _Input2.default
}, _class.stylesheet = Stylesheet.create({
  Root: 'div',
  ErrorList: _ErrorList2.default,
  Label: _Label2.default,
  InputWrapper: 'div'
}), _temp);
exports.default = Field;
